import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';

import { bottomBorderStyle, colorPalette, TextSizesEnum, topBorderStyle } from '../../../theme';
import { ButtonColor, PlexButton } from '../../shared/primitives/PlexButton';
import { PlexTypography } from '../../shared/primitives/PlexTypography';

type Props = {
  children: React.ReactNode;
  loadingMutation: boolean;
  updateDisabled: boolean;
  onCancel?: () => void;
  onSave?: () => void;
  title: string;
  hideActions?: boolean;
};

export const SettingsContent = ({
  children,
  loadingMutation,
  updateDisabled,
  onCancel,
  onSave,
  title,
  hideActions,
}: Props): React.ReactElement => {
  const classes = useStyles();
  return (
    <div className={classes.contentContainer}>
      <PlexTypography className={classes.title} text={title} size={TextSizesEnum.XXLarge} />
      <div className={classes.content}>{children}</div>
      {!hideActions && (
        <div className={classes.bottom}>
          {onCancel && (
            <PlexButton
              color={ButtonColor.TransparentGray}
              label={'Cancel'}
              className={classes.button}
              onClick={onCancel}
            />
          )}
          {onSave && (
            <PlexButton
              label={loadingMutation ? 'Updating...' : 'Update'}
              className={classes.button}
              onClick={onSave}
              disabled={updateDisabled}
            />
          )}
        </div>
      )}
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    },
    title: {
      display: 'flex',
      flexBasis: 100,
      ...bottomBorderStyle,
      alignItems: 'center',
      paddingLeft: 48,
      fontWeight: 600,
      color: colorPalette.general.text2,
    },
    content: {
      display: 'flex',
      flex: 1,
      overflow: 'scroll',
      justifyContent: 'center',
      alignContent: 'flex-start',
      flexWrap: 'wrap',
    },
    bottom: {
      display: 'flex',
      flexBasis: 100,
      ...topBorderStyle,
      width: '100%',
      padding: 24,
      justifyContent: 'flex-end',
    },
    button: {
      borderRadius: 27,
      padding: '0 25px',
      margin: '0 5px',
    },
  })
);
